<template>
  <div class="director-page">
    <div class="item">
      <img src="@/assets/img/player/director_01.png" class="director-img" alt="">
      <ul class="director-info">
        <li>
          <p class="name">{{directorInfo.name}}</p>
          <p class="sub">{{directorInfo.engNm}}</p>
        </li>
        <li>
          <p>{{directorInfo.position}}</p>
          <p>{{directorInfo.birthday}}</p>
          <p>{{directorInfo.education}}</p>
        </li>
      </ul>
    </div>

    <table v-if="playerCareer.length > 0">
      <caption>선수경력</caption>
      <tbody>
        <tr v-for="(item, index) in playerCareer" :key="index">
          <th>{{item.title}}</th>
          <td>{{item.text}}</td>
        </tr>
      </tbody>
    </table>

    <table>
      <caption>지도자 경력</caption>
      <tbody>
      <tr v-for="(item, index) in leaderCareer" :key="index">
        <th class="width">{{item.title}}</th>
        <td>{{item.text}}</td>
      </tr>
      </tbody>
    </table>

    <table v-if="leaderAwards.length > 0">
      <caption>지도자 수상경력</caption>
      <tbody>
      <tr v-for="(item, index) in leaderAwards" :key="index">
        <th>{{item.title}}</th>
        <td>{{item.text}}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import director from '@/components/Player/Json/director'
export default {
  name: 'Director',
  data() {
    return {
      directorInfo: {},
      playerCareer: [],
      leaderCareer: [],
      leaderAwards: []
    }
  },
  mounted () {
    this.getDirectorInfo();
  },
  methods: {
    getDirectorInfo() {
      this.directorInfo = director.directorInfo;
      this.playerCareer = director.playerCareer;
      this.leaderCareer = director.leaderCareer;
      this.leaderAwards = director.leaderAwards;
    }
  }
}
</script>
